import { FC } from 'react'
import cn from 'classnames'

import { formatDate } from 'pages/account/savings/info/deposit-active/components/transactions/utils'

import FilterTab from './filter-tab'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

interface Filter<T = any> {
  labels: any
  state: T[]
  onSelect: (filter: T | T[]) => void
}

interface Sorting {
  label: string
  isActive: boolean
  onRemove: () => void
}

interface SortingConfig {
  label: string
  state: number
  setState: (value: number) => void
}

interface DateProps {
  startDate: Date | null
  endDate: Date | null
  handleClearCalendar: () => void
}

interface ChosenFiltersTabsProps {
  filters?: Filter[]
  sortings?: SortingConfig[]
  date?: DateProps
  clearAll: () => void
}

export const ChosenFiltersTabs: FC<ChosenFiltersTabsProps> = ({ filters = [], sortings = [], clearAll, date }) => {
  const { t } = useTranslation()
  
  const hasActiveFilters = filters.some((filter) => filter.state.length > 0)
  const hasActiveSortings = sortings.some((s) => s.state !== 0)
  const isEmpty = !hasActiveFilters && !hasActiveSortings && !date

  const generateSortings = (label: string, state: number, setState: (value: number) => void): Sorting[] => [
    {
      label: `${label} in ascending order`,
      isActive: state === 1,
      onRemove: () => setState(0),
    },
    {
      label: `${label} in descending order`,
      isActive: state === 2,
      onRemove: () => setState(0),
    },
  ]

  return (
    <div className={cn(styles.tabs, { [styles.hidden]: isEmpty })}>
      {filters.map((filter, index) =>
        filter.state.map((stateValue, i) => (
          <FilterTab key={`${index}-${i}`} label={stateValue} onClick={() => filter.onSelect(stateValue)} />
        )),
      )}
      {sortings.flatMap((sorting) =>
        generateSortings(sorting.label, sorting.state, sorting.setState).map(
          (sort, index) =>
            sort.isActive && <FilterTab key={`${sorting.label}-${index}`} label={sort.label} onClick={sort.onRemove} />,
        ),
      )}
      {date && date.startDate && date.endDate && (
        <FilterTab
          label={`${formatDate(date.startDate)} - ${formatDate(date.endDate)}`}
          onClick={date.handleClearCalendar}
        />
      )}
      {(hasActiveFilters || hasActiveSortings) && <FilterTab label={t('clear_all')} onClick={clearAll} />}
    </div>
  )
}
